export default __webpack_public_path__ + "static/media/cafgu_bg.47b887ab.png";